import { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { ContractResult } from "@/views/contract/manage/ContractManageTypes";
import { summaryModel } from "./summaryModel";
import "@/views/contract/manage/contract-style.less";
import YhTootip from "@/components/YhTootip";


export function DataTable() {

    const {
        loading,
        pgCfg, dataSource, loadData,
        selectedRowKeys, setSelectedRowKeys,
        selectedData, setSelectedData,
    } = summaryModel()

    const columns: ColumnsType<ContractResult> = [
        // {
        //     title: '序号',
        //     align: "center",
        //     width: 60,
        //     render: (v, r, i) => i + 1
        // },
        {
            title: '分支',
            dataIndex: 'branch',
            align: "center",
            width: 80,
            ellipsis: true,
        },
        {
            title: '客户名称',
            dataIndex: 'partnerName',
            width: 200,
            align: "center",
            ellipsis: true,
        },
        {
            title: '客户编码',
            dataIndex: 'partnerCode',
            align: "center",
            width: 140,
            ellipsis: true,
        },
        {
            title: '账户类型',
            dataIndex: 'accountTypeName',
            align: "center",
            width: 120,
            ellipsis: true,
        },
        {
            title: '关联合约单',
            dataIndex: 'num',
            align: "center",
            width: 120,
            ellipsis: true,
        },
        {
            title: '授信额度',
            dataIndex: 'creditAmount',
            align: "center",
            width: 120,
            ellipsis: true,
        },
        {
            title: '已用额度',
            dataIndex: 'usedAmount',
            align: "center",
            width: 120,
            ellipsis: true,
        },
        {
            title: '可用额度',
            dataIndex: 'availableAmount',
            align: "center",
            width: 120,
            ellipsis: true,
        },
        {
            title: '剩余金额',
            dataIndex: 'remainingAmount',
            align: "center",
            width: 120,
            ellipsis: true,

        }
    ];

    useEffect(() => {
        loadData().then();
    }, [])

    const onRow = (record: ContractResult, selected: boolean) => {
        let arr = [];
        let list = [];
        if (selected) {
            arr = Array.from(new Set([...selectedRowKeys, record.partnerCode]));
            list = Array.from(new Set([...selectedData, record]));
        } else {
            arr = selectedRowKeys.filter(item => { return item !== record.partnerCode });
            list = selectedData.filter(item => item.partnerCode !== record.partnerCode)
        }
        setSelectedRowKeys(arr);
        setSelectedData(list);
    };

    const onSelectAll = (selected: boolean, changeRows: ContractResult[]) => {
        if (selected) {
            let addSelected = [];
            let addRows = [];
            for (const item of changeRows) {
                addSelected.push(item.partnerCode);
                addRows.push(item);
            }
            setSelectedRowKeys([...addSelected, ...selectedRowKeys]);
            setSelectedData([...addRows, ...selectedData]);
        } else {
            setSelectedRowKeys(selectedRowKeys.filter((partnerCode) => {
                return !changeRows.some((item) => item.partnerCode === partnerCode)
            }));
            setSelectedData(selectedData.filter((data) => {
                return !changeRows.some((item) => item.partnerCode === data.partnerCode)
            }));
        }
    }

    return (
        <Table
            loading={loading}
            className='tableHeight'
            rowKey={record => record.partnerCode}
            columns={columns}
            dataSource={dataSource}
            rowSelection={{
                selectedRowKeys: selectedRowKeys,
                onSelectAll: (selected, selectedRows, changeRows) => onSelectAll(selected, changeRows),
                onSelect: (record, selected, selectedRows) => onRow(record, selected),
            }}
            onRow={record => {
                return {
                    onClick: event => onRow(record, !selectedRowKeys.includes(record.partnerCode)),
                    onContextMenu: (e) => {
                        setSelectedRowKeys([record.partnerCode]);
                        setSelectedData([record]);
                    }
                };
            }}
            pagination={{
                ...pgCfg,
                showTotal: (total: number) => `共${total}条`,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            scroll={{ x: 'max-content', y: "calc(100vh - 446px)" }}
        />
    )
}

